module.exports = __webpack_public_path__ + "img/article-2-bg.940a79da.jpg";